var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.7385 12.6749C17.0872 12.3095 17.0872 11.7006 16.7385 11.2947L11.4697 5.774C11.0823 5.40867 10.5012 5.40867 10.1525 5.774L9.2615 6.70765C8.91283 7.11358 8.91283 7.72248 9.2615 8.08782L13.0194 12.0254L9.2615 15.9223C8.91283 16.2877 8.91283 16.8966 9.2615 17.3025L10.1525 18.1956C10.5012 18.6015 11.0823 18.6015 11.4697 18.1956L16.7385 12.6749Z","fill":"#407A7D"}));
}

ChevronRightInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
